import React from "react";

const PPPHeroSection = () => {
  return (
    <section className="relative py-12 sm:py-16 md:py-20 lg:py-24">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-6xl mx-auto text-center">
          <div className="pt-[4rem] sm:pt-[5rem] md:pt-[6rem] pb-6 sm:pb-8" data-aos="fade-up">
            <div className="mb-6 sm:mb-8">
              <h1 className="text-3xl xs:text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight">
                🇸🇦 Semar Holding
              </h1>
              <h2 className="text-xl xs:text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-white mb-3 sm:mb-4 leading-tight">
                Partnering for Vision 2030
              </h2>
              <div className="w-20 sm:w-24 md:w-32 h-1 bg-[#c99c48] mx-auto mb-6 sm:mb-8"></div>
            </div>
            
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl sm:rounded-2xl p-6 sm:p-8 md:p-12 border border-white/20">
              <h3 className="text-lg xs:text-xl sm:text-2xl md:text-3xl font-bold text-white mb-4 sm:mb-6 leading-tight">
                Public-Private Partnerships (PPP) with the National Center for Privatization (NCP)
              </h3>
              <h4 className="text-base xs:text-lg sm:text-xl md:text-2xl font-semibold text-[#c99c48] mb-4 sm:mb-6 leading-tight">
                Driving Sustainable Growth through Strategic Partnerships
              </h4>
              <p className="text-sm xs:text-base sm:text-lg text-gray-100 leading-relaxed max-w-4xl mx-auto">
                At Semar Holding, we are committed to advancing the Kingdom's Vision 2030 by engaging in Public-Private Partnership (PPP) programs led by the National Center for Privatization (NCP). Our goal is to collaborate with government entities across all sectors — from infrastructure and utilities to healthcare, education, defense, transport, and digital transformation — to develop, finance, and operate projects that deliver long-term national value.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PPPHeroSection;
